import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.updateGroup
)

export const selectIsCreateGroupModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreateGroupModalOpen
)

export const selectIsDeleteGroupModalOpen = createSelector(
    baseSelector,
    (state) => state.isDeleteGroupModalOpen
)

export const selectIsGroupAccrualModalOpen = createSelector(
    baseSelector,
    (state) => state.isGroupAccrualModalOpen
)

export const selectIsVisibilityAclModalOpen = createSelector(
    baseSelector,
    (state) => state.isVisibilityAclModalOpen
)

export const selectOnDelete = createSelector(
    baseSelector,
    (state) => state.onDelete
)

export const selectOnAccrual = createSelector(
    baseSelector,
    (state) => state.onAccrual
)

export const selectOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)

export const selectCurrentRole = createSelector(
    baseSelector,
    (state) => state.currentRole
)

export const selectCurrentGroup = createSelector(
    baseSelector,
    (state) => state.currentGroup
)

export const selectOnVisibilityAclChange = createSelector(
    baseSelector,
    (state) => state.onVisibilityAclChange
)

export const selectCurrentUser = createSelector(
    baseSelector,
    (state) => state.currentUser
)

export const selectVisibilityAclSourceType = createSelector(
    baseSelector,
    (state) => state.visibilityAclSourceType
)